import { useContext } from "react";

import classes from "./CartDrinks.module.css";

import CartContext from "../../../store/cart-context";
import CartDrinkBar from "../CartDrinkBar/CartDrinkBar";

// component for all drinks in cart
const CartDrinks = () => {
  const cartCtx = useContext(CartContext);
  let cartDrinks;

  // map all drinks in cart context to a drink bar
  if (cartCtx.items) {
    cartDrinks = (
      <div className={classes.cart_drinks}>
        {cartCtx.items.map((item) => (
          <CartDrinkBar key={item.id} drink={item} />
        ))}
      </div>
    );
  } else {
    cartDrinks = <div></div>;
  }

  return cartDrinks;
};

export default CartDrinks;
